import type Quill from 'quill/core';
import { Delta } from 'quill/core';
import QuillClipboard from 'quill/modules/clipboard';

class SearchInputClipboard extends QuillClipboard {
  constructor(quill: Quill) {
    super(quill, { matchers: [] });
  }

  convert(
    { html, text }: { html?: string | undefined; text?: string | undefined },
    formats?: Record<string, unknown>,
  ): Delta {
    const delta = super.convert({ html, text }, formats);
    return new Delta(
      delta.map((op) => {
        if (typeof op.insert === 'string') {
          return {
            ...op,
            insert: op.insert.replace(/\n/g, ' '),
          };
        }
        return op;
      }),
    );
  }
}

export default SearchInputClipboard;
